export enum Status {
  NOT_AUTHENTICATED,
  AUTHENTICATED,
  ERROR,
}
